import { FullCenterContentComponent } from 'components/FullCenterContent';
import { MainTemplateComponent } from 'components/MainTemplate';
import { MainLoadingComponent } from 'components/MainLoading';
import React from 'react';

export function LoadingScreenComponent() {
    return (
        <MainTemplateComponent className="loading-screen">
            
            <div className="area-content default-margins">
                
                <FullCenterContentComponent className="fixed">
                    <MainLoadingComponent />
                </FullCenterContentComponent>
            </div>
            
        </MainTemplateComponent>
    );
};